export default __webpack_public_path__ + "static/media/profile-img.52b5cd6e.png";